import React, {Component} from 'react'
import IntegrationEditForm from "./form/edit.component.jsx"
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import SideBar from '../common/layout/sidebar.component.jsx'

class IntegrationEdit extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            form: '',
            authConnect: this.props.authConnect
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
        const integrationId = this.props.match.params.integrationId
        AppContext.getApiClient().get('/integration-configurations/' + integrationId).then((config) => {
            this.setState({
                form: <IntegrationEditForm value={config} type={config.attributes.integrationKey}
                authConnect={this.state.authConnect}  />
            })
        });
    }

    render() {
        return (
            <div>
                {this.state.form}
            </div>
        );
    }
}

export default IntegrationEdit


// WEBPACK FOOTER //
// ./src/integration/edit.component.jsx